var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/patient-list-report.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-63f621ba!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/patient-list-report.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/PatientListReport.vue
// module id = 340
// module chunks = 1